var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroesseKreis03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-03__Icn/40px/Groesse-Kreis-03",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-03__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-03__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,12 C24.418278,12 28,15.581722 28,20 C28,24.418278 24.418278,28 20,28 C15.581722,28 12,24.418278 12,20 C12,15.581722 15.581722,12 20,12 Z M20,14 C16.6862915,14 14,16.6862915 14,20 C14,23.3137085 16.6862915,26 20,26 C23.3137085,26 26,23.3137085 26,20 C26,16.6862915 23.3137085,14 20,14 Z",
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-03__Oval-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroesseKreis03);
export default __webpack_public_path__ + "static/media/Groesse-Kreis-03.4a5391714115034c67d5183ecf7b1eed.svg";
export { ForwardRef as ReactComponent };